import { DetailsListLayoutMode, ICommandBarItemProps, Spinner } from "@fluentui/react"
import { CabeceraTable } from "../../../components/Table/CabeceraTable"
import { TableBaseComponent } from "../../../components/Table/TableBaseComponent"
import { UseTablaHazard } from "./UseTablaHazard"
import IconHelper from "../../../utils/helpers/iconHelper"
import { FiltroHazard } from "./filtroHazard/FiltroHazard"
import { SetStateAction, useState } from "react"
import { IListaHazardRequest } from "../../../Interfaces/hazard/IHazard"

export const TablaHazard=()=>{
    const { items,
        filter,
        setFilter,
        loading,
        pagination,
        handleResetUpdate,
        onChangeSearch,
        onChangeTake,
        _onkeyUpSearchTable,
        getListaRegistros,
        setControl,ResetFilter,filterElement,setFilterElement,descargarReporte,loadReporte,
        buscar} = UseTablaHazard()
    const [isOpen, setIsOpen] = useState(false);
    const _columns = [
        {
            key: "numeracion",
            name: "N°",
            fieldName: "numeracion",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item, index) => {
               const startIndex = (filter.skip ?? 0);
               return <>{startIndex + (index ?? 0) + 1}</>;
            }
         },
         {
            key: "titulo",
            name: "Titulo",
            fieldName: "titulo",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "descripcion",
            name: "Descripcion",
            fieldName: "descripcion",
            minWidth: 300,
            maxWidth: 300,
         },
         {
            key: "acciones",
            name: "Acciones Inmediatas",
            fieldName: "acciones",
            minWidth: 300,
            maxWidth: 300,
         },
         {
            key: "observaciones",
            name: "Observaciones",
            fieldName: "observaciones",
            minWidth: 300,
            maxWidth: 300,
         },
         {
            key: "incidente",
            name: "Grupo Incidente",
            fieldName: "incidentes",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "elementoEstandar",
            name: "Elemento Estandar",
            fieldName: "elementoEstandar",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "eventoFecha",
            name: "Fecha del registro",
            fieldName: "eventoFecha",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "reportadoFecha",
            name: "Fecha del reporte",
            fieldName: "reportadoFecha",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "reportadoHora",
            name: "Hora del reporte",
            fieldName: "reportadoHora",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "ubicacion",
            name: "Ubicacion",
            fieldName: "ubicacion",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "descripcionUbicacion",
            name: "Descripcion de la Ubicacion",
            fieldName: "descripcionUbicacion",
            minWidth: 300,
            maxWidth: 300,
         },
         {
            key: "condicionInSegura",
            name: "Condicion InSegura",
            fieldName: "condicionInSegura",
            minWidth: 300,
            maxWidth: 300,
         },
         {
            key: "actoInSeguro",
            name: "Acto Inseguro",
            fieldName: "actoInSeguro",
            minWidth: 300,
            maxWidth: 300,
         },
         {
            key: "calificacionInicial",
            name: "Calificacion Inicial",
            fieldName: "calificacionInicial",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "calificacionAcordada",
            name: "Calificacion Acordada",
            fieldName: "calificacionAcordada",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "razonRiesgo",
            name: "Razón Riesgo",
            fieldName: "razonRiesgo",
            minWidth: 300,
            maxWidth: 300,
         },
         {
            key: "unidadOrganizativa",
            name: "Unidad Organizativa",
            fieldName: "unidadOrganizativa",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "codigoPersonaReporta",
            name: "Codigo Persona Reporta",
            fieldName: "codigoPersonaReporta",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "nombrePersonaReporta",
            name: "Nombre Persona Reporta",
            fieldName: "nombrePersonaReporta",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "codigoPersonaSocio",
            name: "Codigo Persona Socio",
            fieldName: "codigoPersonaSocio",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "nombrePersonaSocio",
            name: "Nombre Persona Socio",
            fieldName: "nombrePersonaSocio",
            minWidth: 200,
            maxWidth: 200,
         },
         {
            key: "empresaContratista",
            name: "Empresa Contratista",
            fieldName: "empresaContratista",
            minWidth: 200,
            maxWidth: 200,
         },
    ]
    const buttonLeft: ICommandBarItemProps[] = [
        {
           ...IconHelper.ICON_RELOAD,
           text: "Actualizar",
           onClick: () => {
              handleResetUpdate()
              getListaRegistros()
           },
        }
     ];
     const buttonRight: ICommandBarItemProps[] = [
        {
           ...IconHelper.ICON_BS_FILTER,
           text: "Buscar",
           onClick: () => {
              setIsOpen(true)
           },
        },
        {
         ...IconHelper.ICON_EXCEL,
         text: "Descargar",
         onClick: () => {
             descargarReporte()
         },
     }
     ];
    return (
        <> 
           <CabeceraTable
              Titulo={"Hazard"}
              SubTitulo={"Lista de Registros Hazard"}
              placeholder="Buscar Por Modelo"
              componentRef={onChangeSearch}
              onKeyUp={_onkeyUpSearchTable}
           />
           {loadReporte && (<Spinner></Spinner>)}
           <TableBaseComponent
              leftBar={buttonLeft}
              rigthBar={buttonRight}
              data={items}
              column={_columns}
              isLoading={loading}
              getPageSize={onChangeTake}
              pagination={pagination}
              layout={DetailsListLayoutMode.justified}
           />
           <FiltroHazard filtro={filterElement} setFiltro={setFilterElement} resetFilter={ResetFilter} buscar={buscar}  isOpen={isOpen} onDismiss={()=>{setIsOpen(false)}}/>
        </>
    )
}